import { API, Auth } from 'aws-amplify';

/**
 * This method will retrieve JWT token of current session.
 */
const getHeaders = async () => ({
  Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
});

export class Api {
  apiName: string;
  constructor(apiName: string) {
    this.apiName = apiName;
  }

  /**
   * This method will create data.
   */
  async get(path: string) {
    return API.get(this.apiName, path, {
      headers: await getHeaders(),
    })
      .then((response) => response)
      .catch((error) => {
        throw new Error(error.response.data.message);
      });
  }

  /**
   * This method will create data.
   */
  async post(path: string, payload: any) {
    return API.post(this.apiName, path, {
      headers: await getHeaders(),
      body: payload,
    })
      .then((response) => response)
      .catch((error) => {
        throw new Error(error.response.data.message);
      });
  }
}
